//Icons
export const REACHIQ_ICON = "/assets/icons/REACHIQ_ICON.svg";
export const EDIT_COLUMNS_ICON = "/assets/icons/Columns.svg";
export const CHECK_ICON = "/assets/icons/Check.svg";
export const CHECK_ORANGE_ICON = "/assets/icons/check_orange.svg";
export const SORT_BY_ICON = "/assets/icons/SortByIcon.svg";
export const POLYGON_ICON = "/assets/icons/Polygon.svg";
export const CROWN_ICON = "/assets/icons/crown.svg";
export const EMAIL_ICON = "/assets/icons/email.svg";
export const PHONE_ICON = "/assets/icons/phone.svg";
export const TECHNOLOGY_ICON = "/assets/icons/technology.svg";
export const RESET_ICON = "/assets/icons/reset.svg";
export const USERS_ICON = "/assets/icons/users.svg";
export const KEY_ICON = "/assets/icons/key.svg";
export const LOGIN_CROSS_ICON = "/assets/icons/login-cross.svg";
export const GOOGLE_ICON = "/assets/icons/google.svg";
export const MICROSOFT_ICON = "/assets/icons/microsoft.svg";
export const USER_ICON = "/assets/icons/UserIcon.svg";
export const EDIT_ICON = "/assets/icons/edit.svg";
export const THEME_ICON = "/assets/icons/theme.svg";
export const SNACKBAR_SUCCESS_ICON = "/assets/icons/snackbar_success_icon.svg";
export const SNACKBAR_CLOSE_ICON = "/assets/icons/snackbar_close_icon.svg";
export const SNACKBAR_ERROR_ICON = "/assets/icons/snackbar_error_icon.svg";
export const NOT_FOUND_ICON = "/assets/images/notFound.svg";

//Images
export const USER_IMAGE = "/assets/images/user.jpg";
export const DARK_THEME_IMAGE = "/assets/images/darkTheme.png";
export const LIGHT_THEME_IMAGE = "/assets/images/lightTheme.png";
export const AUTO_THEME_IMAGE = "/assets/images/autoTheme.png";
export const LOGIN_ANALYTICS_IMAGE = "/assets/images/LANDING_PAGE.svg";
export const LOGIN_BACKGROUND = "/assets/images/revo-login-bg.svg";
export const LOGIN_REACHIQ_LOGO = "/assets/images/login_reachiq.svg";
export const NEW_LOGIN_REACHIQ_LOGO = "/assets/images/new_logo_reachiq.svg";
export const AUTH_ASIDE_LOGO = "/assets/images/Logo-Full-white.svg";

export const USA_FLAG = "/assets/images/usa-flag.png";
export const INDIA_FLAG = "/assets/images/india-flag.jpeg";
export const DONE_IMAGE = "/assets/images/done.png";
export const SORRY_IMAGE = "/assets/images/Sorry.gif";

export const LEFT_IMAGE = "/assets/images/leftImage.svg";
export const RIGHT_IMAGE = "/assets/images/rightImage.svg";
// gifs

export const DONE_GIF = "/assets/gifs/done.gif";
